import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from 'dibs-elements/exports/Tooltip';
import { TooltipHeader } from 'dibs-elements/exports/TooltipHeader';
import CloseIcon from 'dibs-vg/dist/react/close';

import { saveToStorage } from './favoritesCalloutHelpers';

import styles from './Callout.scss';

export class Callout extends Component {
    state = {
        dismissed: false,
    };

    onCalloutClose(type) {
        this.setState({ dismissed: true }, saveToStorage({ type, turnOff: true }));
    }

    render() {
        const { copy, type } = this.props;
        const { dismissed } = this.state;
        return (
            <Tooltip isVisible={!dismissed} tooltipDirection="top" type="coachmark">
                <TooltipHeader title={this.props.copy.header} />
                <div>{copy.text}</div>
                <span
                    className={styles.close}
                    onClick={() => this.onCalloutClose(type)}
                    data-tn="callout-close"
                >
                    <CloseIcon className={styles.closeButton} />
                </span>
            </Tooltip>
        );
    }
}

Callout.propTypes = {
    copy: PropTypes.object,
    type: PropTypes.string,
};
